import { Dialog, TextField as MuiTextField } from "@mui/material";
import styled from 'styled-components';
import { media } from '../../theme/breakpoints';
import theme from '../../theme/theme';

export const DropZone = styled.div<{ $isDraggingOver: boolean }>`
    border: 2px dashed ${(props) => (props.$isDraggingOver ? 'rgba(4, 47, 152, 0.5)' : '#dde2e6')};
    border-radius: 8px;
    background: ${(props) => (props.$isDraggingOver ? 'rgba(4, 47, 152, 0.05)' : '#ffffff')};
    padding: 24px;
    text-align: center;
    transition: all 0.2s ease-in-out;
    margin-bottom: 16px;
    cursor: pointer;

    p {
        margin: 0;
        color: ${(props) => (props.$isDraggingOver ? 'rgba(4, 47, 152, 0.8)' : '#666')};
    }
`;

export const Button = styled.button`
    font-family: 'Manrope', sans-serif;
    margin-top: 10px;
    border: none;
    font-size: 14px;
    width: 100%;
    background: transparent;
    text-align: center;
    cursor: pointer;
    background: ${theme.palette.primary.main};
    color: white;
    border-radius: 8px;
    padding: 8px 16px;
    font-weight: 600;
    transition: background 0.2s ease;
    
    &:hover {
        background: #152033;
    }

    @media (max-width: 600px) {
        padding-left: 0 !important;
    }
`;

export const FileList = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 10px 0 0 0;

    li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px;
        border-bottom: 1px solid #eee;

        &:last-child {
            border-bottom: none;
        }
    }

    button {
        background: none;
        border: none;
        cursor: pointer;
        color: #042f98;
        font-size: 16px;
    }
`;

export const StyledDialog = styled(Dialog)`
    .MuiPaper-root {
        width: 100%;
        min-width: unset;
        background: white;

        ${media.sm} {
            min-width: 550px;
            width: 550px;
        }
    }
`;

export const ModalHeader = styled.h3`
    font-family: 'Manrope', sans-serif;
    padding: 16px 24px;
    font-size: 1.25rem;
    font-weight: 600;
    margin: 0;
    text-align: left;
`;

export const ModalBody = styled.div`
    font-family: 'Manrope', sans-serif;
    padding: 32px !important;
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

export const ModalFooter = styled.div`
    font-family: 'Manrope', sans-serif;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding-top: 8px;
    padding-left: 24px;
    padding-bottom: 20px !important;
    padding-right: 20px !important;
`;

export const StyledTextField = styled(MuiTextField)`
    .MuiInputBase-root {
        border-radius: 8px;
        font-family: 'Manrope', sans-serif;
    }

    .MuiOutlinedInput-root {
        &.Mui-focused fieldset {
            border-color: #1976D2;
        }
    }

    label.Mui-focused {
        color: #1976D2;
    }
`;
